export const MAINT_STATUS = {
    requested: { el: 'Νέο αίτημα', en: 'New request', cls: 'bg-blue-100 text-blue-700' },
    pending_workshop: { el: 'Αναμονή συνεργείου', en: 'Awaiting workshop', cls: 'bg-orange-100 text-orange-700' },
    date_proposed: { el: 'Πρόταση νέας ημ/νίας', en: 'New date proposed', cls: 'bg-fuchsia-100 text-fuchsia-700' },
    scheduled: { el: 'Προγραμματισμένη', en: 'Scheduled', cls: 'bg-amber-100 text-amber-700' },
    in_progress: { el: 'Σε εξέλιξη', en: 'In progress', cls: 'bg-sky-100 text-sky-700' },
    awaiting_approval: { el: 'Προς έγκριση', en: 'Awaiting approval', cls: 'bg-teal-100 text-teal-700' },
    completed: { el: 'Ολοκληρωμένη', en: 'Completed', cls: 'bg-green-100 text-green-700' },
    rejected: { el: 'Απορρίφθηκε', en: 'Rejected', cls: 'bg-red-100 text-red-700' },
};

export const MaintStatusBadge = ({ status, el, testId }) => {
    const s = MAINT_STATUS[status] || MAINT_STATUS.requested;
    return <span className={`text-xs px-2 py-0.5 rounded ${s.cls}`} data-testid={testId}>{el ? s.el : s.en}</span>;
};

export const fmtDay = (d, el) => (d ? new Date(`${d.slice(0, 10)}T00:00:00`).toLocaleDateString(el ? 'el-GR' : 'en-GB') : '-');

export const SERVICE_TYPES = [
    { el: 'Τακτικό service', en: 'Regular service' },
    { el: 'Αλλαγή λαδιών', en: 'Oil change' },
    { el: 'Ελαστικά', en: 'Tyres' },
    { el: 'Φρένα', en: 'Brakes' },
    { el: 'ΚΤΕΟ', en: 'MOT / KTEO' },
    { el: 'Βλάβη', en: 'Breakdown' },
    { el: 'Άλλο', en: 'Other' },
];

export const chatLink = (m, type) => {
    const params = new URLSearchParams({ ref: `${m.license_plate} – ${m.service_type}` });
    if (type === 'lessee') { params.set('type', 'lessee'); params.set('party', m.client_company_id); }
    if (type === 'workshop' && m.workshop) { params.set('type', 'workshop'); params.set('party', m.workshop.id); }
    return `/app/leasing-chat?${params.toString()}`;
};
